import { useRef } from 'react'

export const useDebounce = () => {
  const lastCalled = useRef<number>()

  const debounce = (callback: () => void, time: number) => {
    if (lastCalled.current && Date.now() - lastCalled.current < time) return
    callback()
    lastCalled.current = Date.now()
  }

  return debounce
}
